module.exports = __webpack_public_path__ + "img/v2.2.68fa5147.png";